import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { outline } from './constants';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiCheckbox']
>['styleOverrides'] = {
  root: () => ({
    ...{
      '&.Mui-focusVisible': {
        outline,
        outlineOffset: '-5px',
      },
    },
  }),
};

const MuiCheckbox: Components<CssVarsTheme>['MuiCheckbox'] = {
  styleOverrides,
};

export default MuiCheckbox;
